import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { isCommonReady, LoadGuard, RouteKey } from '@contact/upgrade';

import { HistoryContactViewComponent } from './contact-view/contact-view.component';
import { HistoryComponent } from './history.component';
import { HistoryInteractionViewComponent } from './interaction-view/interaction-view.component';

export enum HistoryState {
  CONTACT = 'contact',
  INTERACTION = 'interaction',
}

const routes: Routes = [
  {
    path: '',
    component: HistoryComponent,
    canActivate: [LoadGuard.forSelectors([isCommonReady])],
    data: {
      [RouteKey.RequiresAuth.key]: true,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: HistoryState.CONTACT,
      },
      {
        path: HistoryState.CONTACT,
        component: HistoryContactViewComponent,
      },
      {
        path: HistoryState.INTERACTION,
        component: HistoryInteractionViewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HistoryRoutingModule {}
